import { render } from "./pointsManage.vue?vue&type=template&id=0701d78b"
import script from "./pointsManage.vue?vue&type=script&lang=js"
export * from "./pointsManage.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/marketing/pointsManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0701d78b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0701d78b', __exports__)) {
    console.log('reload')
    api.reload('0701d78b', __exports__)
  }
  
  module.hot.accept("./pointsManage.vue?vue&type=template&id=0701d78b", () => {
    console.log('re-render')
    api.rerender('0701d78b', render)
  })

}


export default __exports__